<template>
  <div class="z-10 bg-white md:sticky md:top-0">
    <SearchFilter
      :button-label="buttonLabel"
      @filter-parameters="handleFilterParameters"
    />
  </div>
  <div class="px-4 mx-auto mt-5 mb-20 md:px-0 md:max-w-6xl">
    <div class="flex flex-col items-start mt-5 text-gray-700">
      <PropertySorting
        :property-type-title="title"
        :properties-count="propertiesCount"
        @property-filter="handleFilterParameters"
      />
      <BuildingTypes
        :property-types="propertyTypes"
        @get-properties-by-property-type="handleFilterParameters"
      />
    </div>

    <div class="flex flex-col md:flex-row">
      <div v-if="properties.length > 0">
        <Properties :properties="properties" :isFullWidth="false" />
      </div>
      <div v-else>
        <Properties
          :properties="propertiesBeforeProjects"
          :isFullWidth="false"
        />
        <div class="my-10" v-if="projects">
          <Projects :projects="projects" />
        </div>
        <Properties
          :properties="propertiesAfterProjects"
          :isFullWidth="false"
        />
      </div>
      <div class="flex-col hidden w-full pl-5 mt-10 md:flex">
        <AdBanner />
      </div>
    </div>
  </div>
  <propertiesPageDescription />
</template>
<script>
import { ref, onMounted, watch } from "vue";
import SearchFilter from "@/features/properties/SearchFilter.vue";
import PropertySorting from "@/features/properties/PropertySorting.vue";
import BuildingTypes from "@/features/properties/BuildingTypes.vue";
import Properties from "@/features/properties/PropertyCard.vue";
import Projects from "@/features/properties/NewProjects.vue";
import AdBanner from "@/components/AdBanner.vue";
import { useProperties } from "@/composables/useProperties";
import propertiesPageDescription from "@/features/properties/DescriptionView.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";

export default {
  name: "PropertiesView",
  components: {
    SearchFilter,
    // BreadCrumb,
    PropertySorting,
    BuildingTypes,
    Properties,
    Projects,
    AdBanner,
    propertiesPageDescription,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const base_url = store.state.baseUrl;
    const tenure_name = ref({});
    const selectedItem = ref(null);
    const slug = router.currentRoute.value.params.slug;
    const {
      fetchPropertyData,
      properties,
      propertiesBeforeProjects,
      propertiesAfterProjects,
      propertiesCount,
      propertyTypes,
      title,
      buttonLabel,
      projects,
      getProjects,
    } = useProperties();

    if (slug === "properties-for-rent") {
      tenure_name.value = "rent";
    } else if (slug === "properties-for-sale") {
      tenure_name.value = "buy";
    } else if (slug === "properties-for-short-stay") {
      tenure_name.value = "short-stay";
    } else if (slug === "commercial-properties") {
      tenure_name.value = "commercial";
    }

    const handleFilterParameters = async (payload) => {
      try {
        const queryParams = {
          sort_by: payload.itemId ?? "",
          keyword: payload.keyword ?? "",
          property_tenure_option_id: payload.property_tenure_option_id ?? "",
          property_tenure_option_name: tenure_name.value ?? "",
          property_type_id: payload.property_type_id ?? "",
          number_of_beds: payload.number_of_beds ?? "",
          number_of_baths: payload.number_of_baths ?? "",
          min_price: payload.minPrice ?? "",
          max_price: payload.maxPrice ?? "",
          furnishing_status: payload.furnishing_status ?? "",
          amenity_id: payload.amenity_id ?? "",
        };
        const response = await axios.get(`${base_url}property-filters`, {
          params: queryParams,
        });
        properties.value = response.data.data;
        propertiesBeforeProjects.value = [];
        propertiesAfterProjects.value = [];
        propertiesCount.value = response.data.data.length;
      } catch (error) {
        console.error(error.message);
      }
    };

    const runOnMounted = async () => {
      try {
        let routeValue = router.currentRoute.value;
        let query = routeValue.query;

        const queryParams = {
          sort_by: query.sort_by ?? "",
          keyword: query.keyword ?? "",
          property_tenure_option_id: query.property_tenure_option_id ?? "",
          property_tenure_option_name: tenure_name.value ?? "",
          property_type_id: query.property_type_id ?? "",
          property_type_name: query.property_type ?? "",
          town_name: query.town ?? "",
          city_name: query.city ?? "",
          place: query.property_type_id ?? "",
          number_of_beds: query.number_of_beds ?? "",
          number_of_baths: query.number_of_baths ?? "",
          min_price: query.min_price ?? "",
          max_price: query.max_price ?? "",
        };

        const hasQueryParams = Object.keys(queryParams).some(
          (key) => queryParams[key] !== ""
        );

        if (hasQueryParams) {
          const response = await axios.get(`${base_url}property-filters`, {
            params: queryParams,
          });
          properties.value = response.data.data;
          propertiesCount.value = response.data.data.length;
          propertiesBeforeProjects.value = [];
          propertiesAfterProjects.value = [];
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    watch(
      () => router.currentRoute.value,
      () => {
        handleFilterParameters();
      }
    );

    onMounted(() => {
      const currentRoute = router.currentRoute.value.params.slug;
      fetchPropertyData(currentRoute);
      getProjects();
      if (Object.keys(router.currentRoute.value.query).length > 0) {
        runOnMounted();
      }
    });

    return {
      slug,
      buttonLabel,
      title,
      properties,
      propertiesBeforeProjects,
      propertiesCount,
      propertyTypes,
      propertiesAfterProjects,
      projects,
      selectedItem,
      handleFilterParameters,
    };
  },
};
</script>

<!-- 
<template>
  <div class="sticky top-0 z-10 bg-white">
    <SearchFilter
      :button-label="buttonLabel"
      @filter-parameters="handleFilterParameters"
    />
  </div>
  <div class="mx-auto mt-5 mb-20 md:max-w-6xl">
    <div class="flex flex-col items-start mt-5 text-gray-700">
      <PropertySorting
        :property-type-title="title"
        :properties-count="propertiesCount"
        :ads="top"
        @property-filter="handleFilterParameters"
      />
      <BuildingTypes
        :property-types="propertyTypes"
        @get-properties-by-property-type="handleFilterParameters"
      />
    </div>

    <div class="flex flex-col md:flex-row">
      <div v-if="properties.length > 0">
        <Properties :properties="properties" :isFullWidth="false" />
      </div>
      <div v-else>
        <Properties
          :properties="propertiesBeforeProjects"
          :isFullWidth="false"
        />
        <div class="my-10" v-if="projects">
          <Projects :projects="projects" />
        </div>
        <Properties
          :properties="propertiesAfterProjects"
          :isFullWidth="false"
        />
      </div>
      <div class="flex-col hidden w-full pl-5 mt-10 md:flex">
        <AdBanner />
      </div>
    </div>
  </div>
  <propertiesPageDescription />
</template>

<script>
import { onMounted, watch } from "vue";
import { useRouter } from "vue-router";
// import { useStore } from "vuex";
import SearchFilter from "@/features/properties/SearchFilter.vue";
import PropertySorting from "@/features/properties/PropertySorting.vue";
import BuildingTypes from "@/features/properties/BuildingTypes.vue";
import Properties from "@/features/properties/PropertyCard.vue";
import Projects from "@/features/properties/NewProjects.vue";
// import SearchTypes from "@/features/properties/SearchTypes.vue";
import propertiesPageDescription from "@/features/properties/DescriptionView.vue";
import AdBanner from "@/components/AdBanner.vue";
import { useProperties } from "@/composables/useProperties";
import { useFilters } from "@/composables/useFilters";

export default {
  name: "PropertiesView",
  components: {
    SearchFilter,
    PropertySorting,
    BuildingTypes,
    Properties,
    Projects,
    // SearchTypes,
    propertiesPageDescription,
    AdBanner,
  },
  setup() {
    const {
      fetchPropertyData,
      properties,
      propertiesBeforeProjects,
      propertiesAfterProjects,
      propertiesCount,
      propertyTypes,
      title,
      buttonLabel,
      projects,
      getProjects,
    } = useProperties();
    const { handleFilterParameters, runOnMounted } = useFilters();

    const router = useRouter();

    onMounted(() => {
      const currentRoute = router.currentRoute.value.params.slug;
      fetchPropertyData(currentRoute);
      getProjects();
      if (Object.keys(router.currentRoute.value.query).length > 0) {
        runOnMounted();
      }
    });

    watch(
      () => router.currentRoute.value,
      () => {
        handleFilterParameters();
      }
    );

    return {
      handleFilterParameters,
      properties,
      propertiesBeforeProjects,
      propertiesAfterProjects,
      propertiesCount,
      propertyTypes,
      title,
      buttonLabel,
      projects,
    };
  },
};
</script> -->
